module.exports = __webpack_public_path__ + "img/icon-close-flame.66878c3e.svg";